const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
    cellStyle: { lineHeight: '20px' },
};

const initialState = {
    columns: [],
    rowData: [],
    tableName: '',
    columnDefinitions: [],
    reconExplorerViews: [],
    reconSummaryData: [],
    sourceSummaryData: [],
    gridOptions: {
        defaultColDef,
        columnDefs: [],
        sideBar: {
            toolPanels: ['columns'],
            defaultToolPanel: '',
        },
        enableRangeSelection: true,
        animateRows: true,
        allowContextMenuWithControlKey: true,
        rowGroupPanelShow: 'always',
        headerHeight: 35,
    },
    contextMenuItems: [],
    matchRuleName: '',
    matchRefId: '',
    matchDate: '',
    totalCountData: [{ matched: 0, unmatched: 0, proposed: 0 }],
    todayCountData: [{ matched: 0, unmatched: 0, proposed: 0 }],
    labelData: [],
    ageData: [{ matched: 0, unmatched: 0, proposed: 0 }],
    daysData: [
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
        { matched: 0, unmatched: 0, proposed: 0 },
    ],
    recordsForReconAuth: [],
    summaryFlowDetails: [],
    fundDetails: [],
};

export default initialState;
